import {Injectable, Inject} from '@angular/core';
import { CanActivate, ActivatedRoute } from '@angular/router';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import 'rxjs/add/operator/map';
import { User } from '../data-models/user.class';

@Injectable()

export class AuthGuard implements CanActivate {

    constructor(private auth: AuthService,
        private router: Router) {

           
    }

    canActivate(route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean>|boolean {
        const isLoggedIn = this.auth.isLoggedIn();
        //console.log('inside authguard', isLoggedIn);
        if (isLoggedIn) {
            return true;
        }
        // this.router.navigate(['/auth/login/simple']);
        this.router.navigate(['/auth/login/simple'], { queryParams: { returnUrl: state.url }});
        return false;

    }
}
